module.exports = __webpack_public_path__ + "assets/img/icon_picture_book.098452b5.png";